import React from 'react';
import i18n from '../../../i18n';
import { MzadLoader } from '../../helpers/mzadLoader';
import { getAllOfficers } from '../../../models/officers';
import swal from 'sweetalert';
import { getMeetingAttendees, updateMeetingAttendeesList } from '../../../models/meetings';

let lang = localStorage.getItem('I18N_LANGUAGE');
class AttendeesEdit extends React.Component {
  constructor() {
    super();
    this.state = {
      officers: [],
      attendees: [],
      group: {},
      officers_loading: false,
      selected_location: false,
      saving_attendees: false,
    };
    this.handleAttendees = this.handleAttendees.bind(this);
  }

  componentDidMount() {
    this.loadOfficers();
  }

  handleCheckboxChange = (itemId) => {
    this.setState((prevState) => {
      const updatedOfficers = prevState.officers.map((item) =>
        item.id === itemId ? { ...item, isChecked: !item.isChecked } : item,
      );

      const selectedIds = updatedOfficers.filter((item) => item.isChecked).map((item) => item.id);

      const selectedOfficers = selectedIds.map((id) => {
        return {
          id: id,
        };
      });
      console.log(selectedIds);
      return {
        officers: updatedOfficers,
        selected_ids: selectedIds,
        selected_officers: selectedOfficers,
      };
    });
  };

  async loadOfficers() {
    let { id, meeting } = this.props;
    this.setState({ officers_loading: true });
    const response = await getAllOfficers();
    if (response.success) {
      let officers = response.data;
      const at_response = await getMeetingAttendees(id);
      if (at_response.success) {
        let _attendees = at_response.data;
        if (meeting.status === 'N') {
          const attendeeIds = new Set(_attendees.map((attendee) => attendee.officer));
          officers = officers.map((officer) => ({
            ...officer,
            isChecked: attendeeIds.has(officer.id),
          }));
        }
        if (meeting.status === 'C') {
          officers = _attendees;
        }
      }
      this.setState({ officers });
      this.setState({ officers_loading: false });
    }
  }

  async handleAttendees(event) {
    event.preventDefault();
    this.setState({ saving_attendees: true });
    try {
      let { selected_ids } = this.state;
      let payload = {
        attendees: selected_ids,
      };
      const response = await updateMeetingAttendeesList(payload, this.props.id);
      if (response.success) {
        swal(i18n.t('success'), 'Attendees added to meeting successfully!!', 'success', {
          buttons: false,
          timer: 2000,
        })
          .then((value) => {
            this.setState({ saving_attendees: false });
            this.props.onFinished();
          })
          .catch((response) => {
            swal('Failed', response.message, 'error');
          });
      } else {
        let error_message = response.message;
        let resObject = response.data;
        for (const key in resObject) {
          if (Object.hasOwnProperty.call(resObject, key)) {
            let element = resObject[key];
            error_message += '\n' + element;
          }
        }
        swal('Failed', error_message, 'error');
      }
    } catch (err) {
      console.log(err);
    }
  }

  render() {
    let { officers_loading, officers, saving_attendees } = this.state;
    let { meeting } = this.props;
    return (
      <>
        <MzadLoader animation="grow" size="md" loading={officers_loading} style={{ position: 'relative' }} />

        <div>
          <table className="table table-responsive">
            <thead>
              <tr>
                {meeting.status === 'N' && <th></th>}
                <th>{i18n.t('sl_no')}</th>
                <th>{i18n.t('name')}</th>
                <th>{i18n.t('rank')}</th>

                <th>{i18n.t('approved')}</th>
                <th>{i18n.t('notes')}</th>
              </tr>
            </thead>
            <tbody>
              {officers.length > 0 &&
                officers.map((item, i) => {
                  return (
                    <tr>
                      {meeting.status === 'N' && (
                        <td>
                          <input
                            type="checkbox"
                            value={item.id}
                            checked={item.isChecked}
                            onChange={() => this.handleCheckboxChange(item.id)}
                            style={{ width: '1.2rem', height: '1.2rem' }}
                          />
                        </td>
                      )}
                      <td>{i + 1}</td>
                      <td>
                        {lang === 'ar' ? item?.name_ar : item?.name}
                        {meeting.status === 'C' && (
                          <>{lang === 'ar' ? item?.officer_info?.name_ar : item?.officer_info?.name}</>
                        )}
                      </td>
                      <td>
                        {item.rank && item.rank_info
                          ? lang === 'ar'
                            ? item?.rank_info?.rank_ar
                            : item?.rank_info?.rank_en
                          : ''}
                        {meeting.status === 'C' && (
                          <>{lang === 'ar' ? item?.officer_rank?.rank_ar : item?.officer_rank?.rank_en}</>
                        )}
                      </td>

                      <td>{item.approved ? i18n.t('yes') : i18n.t('no')}</td>
                      <td>{item?.notes}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          {meeting.status === 'N' && (
            <button
              type="button"
              className="btn btn-primary btn-block mt-5"
              onClick={this.handleAttendees}
              disabled={saving_attendees}
            >
              {saving_attendees ? i18n.t('saving') : i18n.t('submit')}
            </button>
          )}
        </div>
      </>
    );
  }
}

export default AttendeesEdit;
